<template src="./html/Show.html"></template>

<script>
	import TaskCreate from '../../tasks/views/Create.vue'
	import ScheduleCreate from '../../schedules/views/Create.vue'
	import swal from 'sweetalert2'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'task-create': TaskCreate,
			'schedule-create': ScheduleCreate,
		},
		data () {
			return {
				item: null,
			}
		},
		created () {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			getData() {
				this.$http.get('admin/projects/projects/' + this.$route.params.id)
				.then(response => {
					this.item = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			reload() {
				this.$emit('reload')
				this.getData()
			},
			// SCHEDULES
			openCreateSchedule: function(item) {
				this.$refs.schedulecreate.item = item
				this.$refs.schedulecreate.open()
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/Show.vue